import React, { useState } from "react";
import FileSelect from "./Components/FileSelect";
import { v4 as uuid } from "uuid";
import lodash from "lodash-es";
import axios from "axios";
import { ResultMessage } from "../ResultMessage";
import { useLatest, useToggle } from "react-use";
import {
    ChainUploadFileProps,
    onUploadErrorProps,
    onUploadOkProps,
    onUploadProgressProps,
    uploadToQiNiuGen
} from "./servers";
import Style from "./index.module.scss";
import ListItem from "./Components/ListItem";
import { errorMessage } from "../../Utils/useRequest";
import { Modal } from "antd";

interface Props {
    children?: React.ReactChild;
    buttonClass?: string;
    buttonText?: string;
    onUploadSuccess: (files: ChainUploadFileProps[]) => void;
    onCancel: () => void;
    tokenUrl: string;
    uploadUrl: string;
    TypeList: Record<string, string[]>;
}
const Index = ({
    children,
    onUploadSuccess,
    onCancel,
    tokenUrl,
    uploadUrl,
    TypeList,
    ...restProps
}: Props) => {
    const [loading, toggleUploadLoading] = useToggle(false);
    const [fileList, setFileList] = useState<ChainUploadFileProps[]>([]);
    const [cancel, setCancel] = useState<any>();
    const fileListLatest = useLatest(fileList);

    function onFinish() {
        const fileEntityList: ChainUploadFileProps[] =
            fileListLatest.current.map(item => item);
        onUploadSuccess(fileEntityList);
    }

    function SET_LIST(
        index: number,
        percent: number,
        status: "uploading" | "done" | "error" | "pending" | "stop",
        e?: ErrorEvent | undefined,
        res?: { key: string; hash: string } | undefined
    ) {
        setFileList((fileList: ChainUploadFileProps[]) => {
            const _list_ = lodash.cloneDeep(fileList);
            _list_[index].percent = percent;
            _list_[index].status = status;
            _list_[index].error = e;
            _list_[index].response = res;
            return _list_;
        });
    }

    async function onFileSelect(Files: File[]) {
        toggleUploadLoading();
        setFileList(
            Array.from(Files).map(item => {
                return {
                    file: item,
                    uid: uuid(),
                    status: "pending",
                    percent: 0
                };
            })
        );

        function onUploadProgress({
            percent,
            file,
            index
        }: onUploadProgressProps) {
            SET_LIST(index, percent, "uploading");
        }

        function onError({ e, file, index }: onUploadErrorProps) {
            SET_LIST(index, 100, "error", e);
        }

        function onOk({ file, index, res }: onUploadOkProps) {
            SET_LIST(index, 100, "done", undefined, res);
        }

        const cancelToken = new axios.CancelToken(cancel => {
            setCancel(() => cancel);
        });

        function* upload() {
            let index = 0;
            while (index < Files.length) {
                yield uploadToQiNiuGen(
                    Files[index],
                    {
                        onUploadProgress,
                        onError,
                        index,
                        onOk,
                        tokenUrl,
                        uploadUrl,
                        TypeList
                    },
                    cancelToken
                )
                    .then(() => {
                        index++;
                    })
                    .catch(e => {
                        SET_LIST(index, 0, "stop");
                        index++;
                        if (e?.message !== "STOP") {
                            ResultMessage.error(
                                errorMessage(e, "发生错误，请联系管理员")
                            );
                        }
                    });
            }

            return new Promise(resolve => resolve("ALL_FILE_OK"));
        }

        const u = upload();
        let gen = null;
        do {
            gen = u.next();
            const res = await gen.value;
            if (res === "ALL_FILE_OK") {
                onFinish();
            }
        } while (!gen.done);
        toggleUploadLoading();
    }

    function cancelUpload() {
        cancel("STOP");
        onCancel();
    }

    return (
        <div>
            <FileSelect
                {...restProps}
                loading={loading}
                onFileSelect={onFileSelect}>
                {children}
            </FileSelect>

            {loading && (
                <Modal
                    title="文件上传"
                    okButtonProps={{ style: { display: "none" } }}
                    visible={loading}
                    width={700}
                    onCancel={cancelUpload}>
                    <div className={Style.modal}>
                        <div className={Style.main}>
                            <div className={Style.upList}>
                                {Array.from(fileList).map((item: any) => {
                                    return (
                                        <ListItem key={item.uid} file={item} />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default Index;
